import { render, staticRenderFns } from "./reinstatiate.vue?vue&type=template&id=c9b33084&functional=true"
import script from "./reinstatiate.vue?vue&type=script&lang=js"
export * from "./reinstatiate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports